import { APIState } from "./types";

const initialState: APIState = {
  authFetch: true,
  authCertsFetch: false,
  authDuoFetch: false,
  authError: false,
  authSuccess: false,
  authDuoSuccess: false,
  authDuoError: false,
  authErrorMsg: '',
  authErrorTitle: '',
  authCerts: false,
  authServer: false,
  token: null,
  token2: null,
  duoHost: '',
  sigRequest: '',
  camerasFetch: false,
  camerasSuccess: false,
  camerasError: false,
  cameras: null,
  maps: null,
  webPages: null,
  layoutsFetch: false,
  layoutsSuccess: false,
  layoutsError: false,
  layouts: null,
  username: '',
  bkmsInfo: null,
  sessionTokenIsOver: false,
  eventsInfo: null,
  globalTriggers: [],
  privileges: {
    canBrowse: true,
    canCreateBookmarks: true,
    canDeleteBookmarks: true,
    canViewBookmarks: true
  },
  serviceType: null
};

export default initialState